<template>
    <div>
        <div class="tv-nav">
            <div class="logo">
                <img :src="logo" @click="toHome()"/>
            </div>
        </div>
        <div class="about-app-inset">
            <image-bg 
                :title="'FAQ'" 
                :min-title="'よくあるご質問'"
                :bg-images="banner"
            ></image-bg>
            <div class="msg-area">
                <div class="faq-list">
                    <div class="faq-box" v-for="(n, index) in faqList" :key="index">
                        <div class="faq-title" :class="{ selected: n.isShow }" @click="n.isShow = !n.isShow">
                            <div class="faq-name">
                                {{ n.q }}
                            </div>
                            <div class="faq-show-btn" :class="{ selected: n.isShow }">
                                <div class="faq-show-btn-text">
                                    <caretUpFilled v-if="n.isShow"></caretUpFilled>
                                    <caretDownFilled v-else ></caretDownFilled>
                                </div>
                            </div>
                        </div>
                        <div class="faq-msg" v-show="n.isShow">
                            {{ n.a }}
                        </div>
                    </div>
                </div>
            </div>
            <tv-footer></tv-footer>
        </div>
    </div>
</template>
<script>

import imageBg from '../../components/image-bg'
import tvFooter from '../home/modules/footer'
import { banner } from './images/index'
import logo from '../../images/logo.png'
import faqList from '../../js/faq-data'
import publicMinxin from '../public-minxin'
export default {
    mixins: [publicMinxin],
    components: {
        imageBg,
        tvFooter
    },
    data () {
        return {
            banner,
            logo,
            faqList
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {

        }
    }
}
</script>
<style scoped>
.about-app-inset {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 60px;
    background: #EFEFEF;
}
.msg-area {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 20px;
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
}
.tv-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    z-index: 999;
    border-bottom: solid 2px  #D1D1D1;;
}
.logo img {
    display: block;
    height: 100%;
}
.faq-box {
    width: 100%;
    margin-bottom: 15px;
}
.faq-box .faq-title {
    border-radius: 10px 10px 0 0;
    border:solid 1px #000;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
    padding-right: 50px;
    padding-left: 15px;
    font-weight: bold;
}
.faq-name {

}
.faq-show-btn {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 0;
    bottom: 0;
    right: 10px;
    margin: auto;
    text-align: center;
    line-height: 30px;
    font-size: 15px;
}
.faq-list .faq-box:nth-last-child(1) {
    margin-bottom: 0;
}
.faq-msg {
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    padding: 15px 15px;
    border-radius: 0 0 10px 10px;
}
.faq-title.selected {
    background: #000;
    color: #fff;
}
.faq-title * {
    transition:  all .2s;
}
</style>